import { onError } from '@apollo/client/link/error';

import errorHandler from './errorHandler';

export default onError(errorHandler);
